export const getMedicalRecordsListEndpoint = (appointmentId: number) => `/api/medicalRecords/${appointmentId}/list`;
export const getMedicalRecordEndpoint = (appointmentId: number) => `/api/medicalRecords/${appointmentId}`;
export const getMedicalRecordPdfUrlEndpoint = (medicalRecordId: string) => `/api/medicalRecords/${medicalRecordId}/pdf`;
